import CitySEOHead from "@/components/feature/CitySEOHead";
import PalmBeachHeroSection from "./components/HeroSection";
import PalmBeachStickyNav from "./components/StickyNav";
import PalmBeachProcessingTimeSection from "./components/ProcessingTimeSection";
import PalmBeachServicesSection from "./components/ServicesSection";
import PalmBeachLocalAreaSection from "./components/LocalAreaSection";
import PalmBeachTravelTimingSection from "./components/TravelTimingSection";
import PalmBeachDestinationsSection from "./components/DestinationsSection";
import PalmBeachTestimonialsSection from "./components/TestimonialsSection";
import PalmBeachAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import PalmBeachComparisonSection from "./components/ComparisonSection";
import PalmBeachMistakesSection from "./components/MistakesSection";
import PalmBeachHowItWorksSection from "./components/HowItWorksSection";
import PalmBeachFAQSection, { faqs } from "./components/FAQSection";
import PalmBeachHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import PalmBeachFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const palmBeachServices = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function PalmBeachPage() {
  return (
    <>
      <CitySEOHead
        city="Palm Beach"
        state="Florida"
        stateAbbr="FL"
        route="/cities/palm-beach"
        title="Emergency Passport Palm Beach, FL — Expedited Same-Day Service | Fast Passport Center"
        description="Emergency and expedited passport services in Palm Beach, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving South Florida travelers."
        geoPlacename="Palm Beach, Florida"
        geoPosition="26.7056;-80.0364"
        faqs={faqs}
        servicesSchema={palmBeachServices}
        statePageName="Florida"
        statePageRoute="/states/florida"
      />
      <div className="font-sans">
        <PalmBeachHeroSection />
        <PalmBeachStickyNav />
        <PalmBeachProcessingTimeSection />
        <PalmBeachServicesSection />
        <PalmBeachLocalAreaSection />
        <PalmBeachTravelTimingSection />
        <PalmBeachDestinationsSection />
        <PalmBeachTestimonialsSection />
        <PalmBeachAcceptanceFacilitiesSection />
        <PalmBeachComparisonSection />
        <PalmBeachMistakesSection />
        <PalmBeachHowItWorksSection />
        <PalmBeachFAQSection />
        <PalmBeachHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/cities/palm-beach" state="FL" />
        <PalmBeachFinalCTA />
      </div>
    </>
  );
}